import React, { useState, useEffect } from 'react'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { Formik, Form, Field, FieldArray } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Select from 'react-select';
import { useHistory, useParams } from 'react-router';
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import { useMutation, useQuery } from 'react-query'
import { useQueryClient } from 'react-query'

function AuditorMaster() {
    const { usercode } = useParams()
    const [initialValues, setInitialValues] = useState({
        _id: "",
        userCode: usercode,
        fullName: "",
        eduqualification: "",
        totalWorkExp: "",
        leadAuditTraining: [""],
        auditExperience: "",
        auditorDetails: [{
            anzsicCode: "",
            anzsicName: "",
            eduYesno: "",
            expYesno: "",
            auditorTrainingYesno: "",
            auditlogsYesno: "",
            examinationYesno: ""
        }],
    })

    const { data: certificateList, isLoading: certificateListLoading } = useQuery(
        'listAuditorCertificate',
        () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvaluewithoutselect', {}))

    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listnacecodewithkeylabel', {})
    )

    const { data: auditordetails, isLoading: auditordetailsloading } = useQuery(
        'auditordetails',
        () => Fetcher('get', '/api/profile/get/userdetails/' + usercode, {})
    )

    useEffect(() => {
        if (auditordetails && initialValues._id === "") {
            var tempData = auditordetails.data.response;
            console.log("typeof tempData ", tempData)
            tempData.eduqualification = tempData.eduqualification ? tempData.eduqualification : ""
            tempData.totalWorkExp = tempData.totalWorkExp ? tempData.totalWorkExp : ""
            tempData.leadAuditTraining = tempData.leadAuditTraining ? tempData.leadAuditTraining : ""
            tempData.auditExperience = tempData.auditExperience ? tempData.auditExperience : ""
            tempData.auditorDetails = tempData.auditorDetails && tempData.auditorDetails.length > 0 ? tempData.auditorDetails : [{
                anzsicCode: "",
                anzsicName: "",
                eduYesno: "",
                expYesno: "",
                auditorTrainingYesno: "",
                auditlogsYesno: "",
                examinationYesno: ""
            }]
            setInitialValues(tempData)
        }

    }, [!auditordetailsloading && initialValues.fullName === ""])

    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/profile/patch/auditorinfo', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Data Updated')
                window.location.href = '/' + localStorage.getItem("role") + '/view/' + usercode
            } else {
                var msg = 'Auditor - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Auditor' + error)
        }
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        mutationEdit.mutate(values)
    }
    const validationSchema = Yup.object({
        eduqualification: Yup.string().required("Enter Eduactional Qualification").matches(/^[0-9a-zA-Z]+$/, "Special Characters are not allowed"),
        totalWorkExp    : Yup.string().required("Enter Work Experience").matches(/^[0-9a-zA-Z]+$/, "Special Characters are not allowed"),
        auditExperience : Yup.string().required("Enter Audit Work Experience").matches(/^[0-9a-zA-Z]+$/, "Special Characters are not allowed")
    })

    if (certificateListLoading || nacecodeListLoading || auditordetailsloading) return <h1>Loading</h1>
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row htmlpage">
                                                <div className="col-sm-12">
                                                    <div className="row">
                                                        <div className="col-sm-5">
                                                            <FormikControl className="form-control" control='input' label="Name" name='fullName' disabled={true} />
                                                        </div>
                                                        <div className="col-sm-1" />
                                                        <div className="col-sm-5">
                                                            <FormikControl className="form-control" control='input' label="Educational Qualification *" name='eduqualification' />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-sm-5">
                                                            <FormikControl control='input' label="Total Work Experience *" className="form-control " name='totalWorkExp' />
                                                        </div>
                                                        <div className="col-sm-1" />
                                                        <div className="col-sm-5">
                                                            <FormikControl control='input' label="Audit Experience *" name='auditExperience' />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <label htmlFor="staticEmail" className="col-sm-8 mt-5"> Lead Auditor Training 
                                                        <span className="required-field">*</span>
                                                        </label>
                                                        <div className="col-sm-9" id='groupfour'>
                                                            <FormikControl id='groupone' control='checkbox' name='leadAuditTraining' options={certificateList.data.response} />
                                                        </div>
                                                    </div>
                                                    <div className="container-fluid mt-4 mb-3" style={{ border: "1px solid black" }}>
                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-4 ">ANZ-SIC CODE </label>
                                                            <label htmlFor="staticEmail" className="col-sm-2 "> Exp</label>
                                                            <label htmlFor="staticEmail" className="col-sm-2 "> Auditor Training</label>
                                                            <label htmlFor="staticEmail" className="col-sm-2 "> Audit Logs</label>
                                                            <label htmlFor="staticEmail" className="col-sm-2 "> Examination</label>
                                                        </div>
                                                        <div className="row">
                                                            <FieldArray name='auditorDetails'>
                                                                {fieldArrayProps => {
                                                                    const { push, remove, form } = fieldArrayProps
                                                                    const { values } = form
                                                                    const { auditorDetails } = values
                                                                    return (
                                                                        <div>
                                                                            {auditorDetails.map((auditorDetail, index) => (
                                                                                <div key={index}>
                                                                                    <div className="row mt-2">
                                                                                        <div className="col-sm-4">

                                                                                            <FormikControl control="selectNACECode" name={`auditorDetails[${index}].anzsicCode`} options={nacecodeList.data.response}
                                                                                                onChange={(e) => {
                                                                                                    console.log("e", e)
                                                                                                    formik.setFieldValue(`auditorDetails[${index}].anzsicCode`, e.value)
                                                                                                    formik.setFieldValue(`auditorDetails[${index}].anzsicName`, e.label)
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-sm-2 mt-4 ">
                                                                                            <Field className="form-control" name={`auditorDetails[${index}].expYesno`} as="select" >
                                                                                                <option value="-">Select</option>
                                                                                                <option value="Yes">Yes</option>
                                                                                                <option value="No">No</option>
                                                                                            </Field>
                                                                                        </div>
                                                                                        <div className="col-sm-2  mt-4">
                                                                                            <Field className="form-control" name={`auditorDetails[${index}].auditorTrainingYesno`} as='select'>
                                                                                                <option value="-">Select</option>
                                                                                                <option value="Yes">Yes</option>
                                                                                                <option value="No">No</option>
                                                                                            </Field>
                                                                                        </div>
                                                                                        <div className="col-sm-2  mt-4">
                                                                                            <Field className="form-control" name={`auditorDetails[${index}].auditlogsYesno`} as='select'>
                                                                                                <option value="-">Select</option>
                                                                                                <option value="Yes">Yes</option>
                                                                                                <option value="No">No</option>
                                                                                            </Field>
                                                                                        </div>
                                                                                        <div className="col-sm-2  mt-4">
                                                                                            <Field className="form-control" name={`auditorDetails[${index}].examinationYesno`} as='select'>
                                                                                                <option value="-">Select</option>
                                                                                                <option value="Yes">Yes</option>
                                                                                                <option value="No">No</option>
                                                                                            </Field>
                                                                                        </div>
                                                                                        {index > 0 && (
                                                                                            <div className="col-sm-1">
                                                                                                <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px" }} /></span>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                            <div className="row mt-3">
                                                                                <div className="col-lg-11"></div>
                                                                                <div className="col-lg-1 mb-3" >
                                                                                    <button type='button' className="btn btn-primary" onClick={() => push('')}>Add</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }}
                                                            </FieldArray>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div className="row mt-3">
                                                        <div className="col-lg-11"></div>
                                                        <div className="col-lg-1" >
                                                            <button type="submit" className="btn btn-primary" >Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Form>
            }
        </Formik>
    )
}

export default AuditorMaster
